var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Categories'),_c('Groups'),_c('Priorities')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }